export const environment = {
  production: true,
  jwtName: 'jwt',
  domainLogin: 'https://clientmobile.accpt.rpa360.com',
  domainCookie: 'clientmobile.accpt.rpa360.com',
  tracing: true,
  clientId: 'mobileui',
  issuer: 'https://accpt-api.rpa360.com:4101',
  skipIssuerCheck: false,
  sendToSentry: false,
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0
};
